import React, { useState, useEffect } from "react";
import { AmeaDataContext } from "./context";

import { getAllAmeaData } from "../services/services";
import {
  filterDataSingleValueReturn,
  filterDataWithMultipleDirectives,
} from "../components/Map/helpers";

const AmeaDataProvider = ({ children }) => {
  const [AmeaData, setAmeaData] = useState(null);
  const [infrastructureFilters, setInfrastructureFilters] = useState(null);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const initialInfrastructureFilters = [
    { typeId: "1", type: "category", title: "Ράμπες", isActive: false },
    { typeId: "2", type: "type", title: "Δημόσια", isActive: true },
    {
      typeId: "3",
      type: "category",
      title: "Πεζοδρόμια ΑΜΕΑ",
      isActive: false,
    },
    { typeId: "4", type: "type", title: "Ιδιωτική", isActive: true },
    {
      typeId: "5",
      type: "category",
      title: "Αποδητήρια ΑΜΕΑ",
      isActive: false,
    },
    { typeId: "6", type: "category", title: "Διάβαση τυφλών", isActive: false },
    { typeId: "7", type: "category", title: "Φανάρι με ήχο", isActive: false },
    {
      typeId: "8",
      type: "category",
      title: "Ανελκυστήρες ΑΜΕΑ",
      isActive: false,
    },
    { typeId: "9", type: "category", title: "Άλλο", isActive: false },
  ];

  const filterInfrastructureData = (data) => {
    const currentFilters =
      infrastructureFilters ?? initialInfrastructureFilters;
    let activeCategories = filterDataSingleValueReturn(
      currentFilters?.filter((filter) => filter.type === "category"),
      "isActive",
      "title"
    );
    let activeTypes = filterDataSingleValueReturn(
      currentFilters?.filter((filter) => filter.type === "type"),
      "isActive",
      "title"
    );

    if (
      (activeCategories.length === 0 && activeTypes.length === 0) ||
      (activeCategories.length === 0 && activeTypes.length > 1)
    ) {
      return [];
    } else {
      const filteredData = filterDataWithMultipleDirectives(
        AmeaData?.infrastructures?.data ?? data,
        activeCategories,
        activeTypes,
        "category",
        "type"
      );
      return filteredData;
    }
  };

  const formatRoutes = (routes) => {
    return routes.map((route, id) => {
      const tempRoute = {
        ...route,
        linestring: route.linestring.map((line) => {
          return {
            lat: line[0],
            lng: line[1],
          };
        }),
      };
      return tempRoute;
    });
  };

  useEffect(() => {
    const fetchAmeaData = async () => {
      const Amea = await getAllAmeaData()
        .then((response) => {
          if (Object.keys(response).length > 0) {
            setLoading(false);
            return response;
          } else {
            setLoading(false);
            return [];
          }
        })
        .catch((error) => {
          setLoading(false);
          setError(error);
        });

      const infrastructuresData = {
        data: Amea.infrastructures,
        filteredData: filterInfrastructureData(Amea.infrastructures),
        filters: infrastructureFilters ?? initialInfrastructureFilters,
      };
      const routesData = formatRoutes(Amea.routes);

      // console.log("TEST AMEA DATA: ", {
      //   infrastructures: { ...infrastructuresData },
      //   routes: routesData,
      // });

      //   const tempAmeaRoutes = Amea?.routes.map((route) => {
      //     const tempRoute = route;
      //     if (tempRoute?.linestring) {
      //       tempRoute.linestring = tempRoute?.linestring?.map((linestringSet) => {
      //         return {
      //           lat: linestringSet[0],
      //           lng: linestringSet[1],
      //         };
      //       });
      //       return tempRoute;
      //     }
      //   });

      setAmeaData({
        infrastructures: { ...infrastructuresData },
        routes: routesData,
      });
    };

    if (!AmeaData) {
      fetchAmeaData();
    } else {
      setAmeaData({ ...AmeaData, filteredData: filterInfrastructureData() });
    }
  }, [infrastructureFilters]);

  const updateInfrastructureFilters = (filterId, filterValue) => {
    const updatedFilters = infrastructureFilters.map((filter) =>
      filter.typeId === filterId ? { ...filter, isActive: filterValue } : filter
    );
    setInfrastructureFilters(updatedFilters);
  };

  return (
    <AmeaDataContext.Provider
      value={{
        get: AmeaData,
        updateFilters: updateInfrastructureFilters,
        loading,
        error,
      }}
    >
      {children}
    </AmeaDataContext.Provider>
  );
};

export default AmeaDataProvider;
